import s from './Favourites.module.css';
import { NavigationHeader } from 'components/NavigationHeader/NavigationHeader';
import { useLocation } from 'react-router-dom';
import { BackButton } from 'components/BackButton/BackButton';
import { MenuLabel } from 'components/MenuLabels/MenuLabel';
import { CatsCollectionFavourite } from 'components/CatsCollection/CatsCollectionFavourite';
import { getFavourites } from 'services/API/API';

import { useEffect, useState } from 'react';
import { LabelStyleGallery } from 'components/CatsCollection/LabelStyleGallery';

const Favourites = () => {
  const location = useLocation();
  const [images, setImages] = useState([]);

  useEffect(() => {
    getFavourites(5).then(data =>
      setImages(data.data.map(({ image }) => image))
    );
  }, []);

  getFavourites().then(({ data }) => {
    const favId = data.map(({ image_id }) => image_id);
    localStorage.setItem('favouritesId', JSON.stringify(favId));
  });

  return (
    <div className={s.main}>
      <NavigationHeader />
      <div className={s.gallery}>
        <div className={s.backbutton}>
          <BackButton path={location.state ? location.state.path : '/'} />
          <MenuLabel name={'Favourires'} />
        </div>
        <div className={s.collection}>
          {images.length ? (
            <CatsCollectionFavourite
              images={images}
              destination={'favourites'}
              actualSyleLabelHover={LabelStyleGallery}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export { Favourites };
